<div class="flex justify-between align-center">
  <h3 class="app-form-section-heading mt0 mb3">{{ 'CLIENT_FORM_SECTION.HEADER' | translate }}</h3>

  <mat-slide-toggle
    [checked]="autoIncrementClientId"
    [disabled]="!canSetClientIdAutoIncrement"
    (change)="clientIdAutoIncrementChange.emit($event.checked)"
  >
    {{ 'CLIENT_FORM_SECTION.AUTO_INCREMENT_ID' | translate }}
  </mat-slide-toggle>
</div>

<div class="app-clients">
  <ng-container
    *ngFor="let clientFormGroup of clientsFormArray.controls; index as i"
    class="col-12"
  >
    <app-client-form-card
      class="app-client block col-12 mb2"
      [formGroup]="clientFormGroup"
      [id]="i + 1"
      [displayClose]="clientsFormArray.controls.length > 1 && canRemoveClients"
      (clickClose)="removeClient.emit(i)"
    ></app-client-form-card>
  </ng-container>
</div>

<lib-button
  *ngIf="canAddClient"
  weight="tertiary"
  type="button"
  icon="add"
  [slim]="true"
  (click)="addClient.emit()"
  >{{ 'CLIENT_FORM_SECTION.ADD_PERSON' | translate }}
</lib-button>
